import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=2b765574&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"
import style0 from "./Level.vue?vue&type=style&index=0&id=2b765574&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b765574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b765574')) {
      api.createRecord('2b765574', component.options)
    } else {
      api.reload('2b765574', component.options)
    }
    module.hot.accept("./Level.vue?vue&type=template&id=2b765574&scoped=true", function () {
      api.rerender('2b765574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/HostessCenter/components/Level.vue"
export default component.exports